import { EEarningStatuses, FormattedSavingStatus } from 'store/fetchers/earnings/enum'

export const getFormattedSavingStatus = (status: EEarningStatuses): FormattedSavingStatus => {
  switch (status) {
    case EEarningStatuses.CONFIRMED:
      return FormattedSavingStatus.PENDING
    case EEarningStatuses.CANCELLED:
      return FormattedSavingStatus.CANCELED
    case EEarningStatuses.DEPOSITING:
      return FormattedSavingStatus.PROCESSING
    case EEarningStatuses.ACTIVE:
    case EEarningStatuses.INCREASING:
    case EEarningStatuses.CHARGING:
    case EEarningStatuses.WAITING_WITHDRAW:
    case EEarningStatuses.WITHDRAWING:
    case EEarningStatuses.FAILED:
    case EEarningStatuses.FAILED_BY_PARTNER:
      return FormattedSavingStatus.ACTIVE
    case EEarningStatuses.CLOSED:
      return FormattedSavingStatus.CLOSED
    default:
      return null
  }
}

export const savingCardColumns = ['Account balance', 'Date', 'Annual reward', 'Total earned', 'Status']
